// extracted by mini-css-extract-plugin
export default {"melodyVideo":"FO-z","isFullWidth":"GO-z","landingPageVideo":"HO-z","play":"IO-z","iframeVideo":"JO-z","playHidden":"KO-z","fullwidth":"LO-z"};